import { createFileRoute } from "@tanstack/react-router";
import { ProvidersSharedPage } from "./_components/providers-shared-page";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/shared/",
)({
  component: ProvidersSharedPage,
});
